import React from "react";
import { LayoutPropsType } from "./LayoutTypes";

const Layout = ({ children }: LayoutPropsType) => {
  return <>{children}</>;
};

export default Layout;
